import { Terms, TermsResponse } from '@/api/functions/cms.api';
import { Typography } from '@mui/material';
import { Box, Container } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query';

function Terms_Privacy({slug}:{slug:string}) {
    const [data, setData] = useState<TermsResponse|any>({})
    const {mutate} = useMutation(Terms);
    useEffect(()=>{
        let x = {slug:slug}
        return mutate(x , {onSuccess:(data)=>setData(data)})
    },[])
    console.log(data)
  return (
    <>
        <Container fixed={true}>
            <Typography variant='h2'>{data?.data?.title}</Typography><br/><br/>
            <Box dangerouslySetInnerHTML={{__html: data?.data?.content}} style={{lineHeight:"30px"}}>
            </Box>
        </Container>
    </>
  )
}

export default Terms_Privacy
